export const breakpoints = {
  xs: '600px',
  sm: '768px',
  md: '1200px',
  lg: '1600px',
  xl: '1920px',
};
